<template>
  <!-- SOBRE NOSOTROS -->
  <section class="about-section" ref="aboutSection">
    <div class="about-inner" ref="aboutInner">
      <h2 class="about-title" ref="aboutTitle">Sobre nosotros</h2>
      <p class="about-text" ref="aboutText">
        En EA Magic Cleaning LLC, creemos que cada cliente merece un ambiente limpio, saludable y acogedor.
      <br>  Nuestro equipo de profesionales se compromete a brindar servicios de limpieza confiables y de alta calidad,
        siempre con atención al detalle.
      </p>
      <p class="about-exec" ref="aboutExec">Directora Ejecutiva: <strong>Ivandra Menezes</strong></p>
    </div>
  </section>

  <!-- 🔻 TU SECCIÓN EXACTA, SIN CAMBIOS, DEBAJO DEL “SOBRE NOSOTROS” -->
  <section class="hero-split hero-split--separated" ref="seccion">
    <!-- Imagen izquierda -->
    <div class="split-media" ref="imgWrap">
      <img
        class="split-img"
        :src="imagenSrc"
        :alt="imagenAlt"
        ref="imagen"
        fetchpriority="high"
      />
      <div class="media-fade"></div>
    </div>

    <!-- Contenido derecha -->
    <div class="split-content">
      <h2 class="split-title" ref="titulo">{{ titulo }}</h2>

      <p class="split-sub" ref="sub">
         ¡Haciendo que tu espacio brille como por arte de magia! ✨ <br />
        Servicios de limpieza profesional para casas, departamentos, oficinas, iglesias y más.
        <br />Nos encargamos de la limpieza para que disfrutes de tu tiempo en un espacio fresco e impecable.
      </p>

      <!-- 🔹 Botón -->
      <a class="split-cta" :href="ctaHref" target="_blank" rel="noopener" ref="btn">
        Agendar limpieza
      </a>

      <!-- 🔹 Nuevo bloque destacado -->
      <div class="highlight" ref="highlight">
        <p>
          Puede confiar en nosotros para dejar su casa, oficina o negocio en
          manos de <strong>profesionales de la limpieza</strong>.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'SplitHeroSection',

  props: {
    titulo:    { type: String, default: 'EA Magic Cleaning LLC' },
    imagenSrc: { type: String, default: () => require('@/assets/edificio.jpg') },
    imagenAlt: { type: String, default: 'Sala limpia y ordenada' },
    ctaHref: { 
      type: String, 
default: 'sms:+16122619287?&body=Hola, me interesa informacion sobre Limpieza'
    }
  },

  data() {
    return {
      io: null,
      ctx: null,
      aboutIo: null,
      aboutCtx: null
    }
  },

  async mounted() {
    await nextTick()

    /* ---------- ABOUT: animación al entrar al viewport ---------- */
    const aboutSection = this.$refs.aboutSection
    const aboutTitle   = this.$refs.aboutTitle
    const aboutText    = this.$refs.aboutText
    const aboutExec    = this.$refs.aboutExec

    if (aboutSection) {
      this.aboutCtx = gsap.context(() => {
        gsap.set([aboutTitle, aboutText, aboutExec], { opacity: 0, y: 24 })
      }, aboutSection)

      this.aboutIo = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return
          const tlAbout = gsap.timeline()
          tlAbout
            .to(aboutTitle, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' })
            .to(aboutText,  { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.25')
            .to(aboutExec,  { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.25')

          this.aboutIo.disconnect()
        })
      }, { threshold: 0.25 })

      this.aboutIo.observe(aboutSection)
    }

    /* ---------- HERO SPLIT: tu animación tal cual ---------- */
    const seccion   = this.$refs.seccion
    const imgWrap   = this.$refs.imgWrap
    const imagen    = this.$refs.imagen
    const tituloEl  = this.$refs.titulo
    const sub       = this.$refs.sub
    const btn       = this.$refs.btn
    const highlight = this.$refs.highlight

    if (!seccion) return

    this.ctx = gsap.context(() => {
      gsap.set(imgWrap, { clipPath: 'inset(0 100% 0 0)' })
      gsap.set(imagen, { scale: 1.08, y: 10, opacity: 0 })
      gsap.set([tituloEl, sub, btn, highlight], { opacity: 0, y: 30 })
    }, seccion)

    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return

        const tl = gsap.timeline()
        tl.to(imgWrap, { clipPath: 'inset(0 0% 0 0)', duration: 0.7, ease: 'power3.out' })
          .to(imagen, { opacity: 1, scale: 1, y: 0, duration: 0.9, ease: 'power2.out' }, '-=0.4')
          .to(tituloEl, { opacity: 1, y: 0, duration: 0.45, ease: 'back.out(1.7)' }, '-=0.5')
          .to(sub, { opacity: 1, y: 0, duration: 0.45 }, '-=0.3')
          .to(btn, { opacity: 1, y: 0, duration: 0.45 }, '-=0.3')
          .to(highlight, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, '-=0.2')

        this.io.disconnect()
      })
    }, { threshold: 0.3 })

    this.io.observe(seccion)
  },

  beforeUnmount() {
    if (this.io) this.io.disconnect()
    if (this.ctx) this.ctx.revert()
    if (this.aboutIo) this.aboutIo.disconnect()
    if (this.aboutCtx) this.aboutCtx.revert()
  }
}
</script>


<style scoped>
/* ==== SOBRE NOSOTROS (solo estilos para el bloque superior) ==== */
.about-section {
  background: linear-gradient(135deg, #f8f9fb 0%, #ecf1f8 100%);
  padding: 48px 20px 32px;
}
.about-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 8px;
}
.about-title {
  margin: 0 0 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: clamp(28px, 5vw, 40px);
  color: #0e1a2f;
  letter-spacing: .3px;
}
.about-text {
  margin: 0 0 8px;
  color: #2a3550;
  font-size: 16px;
  line-height: 1.7;
}
.about-exec {
  margin: 6px 0 0;
  color: #2a3550;
  font-size: 16px;
}
.about-exec strong { font-weight: 800; color: #0e1a2f; }

/* ==== TU SECCIÓN EXACTA (NO MODIFICADA) ==== */
.hero-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 76vh;
  background: #ffffff;
  overflow: hidden;
}
.hero-split--separated { margin-top: 48px; }

.split-media { position: relative; overflow: hidden; }
.split-img   { width: 100%; height: 100%; object-fit: cover; display: block; }
.media-fade  { position: absolute; top: 0; left: 0; right: 0; height: 80px;
               background: linear-gradient(to bottom, rgba(255,255,255,0.8), transparent); }

.split-content { display: flex; flex-direction: column; justify-content: center; padding: 48px 64px; }
.split-title   { font-family: 'Montserrat', sans-serif; font-weight: 800; font-size: 38px; color: #0e1a2f; margin-bottom: 16px; }
.split-sub     { font-size: 16px; line-height: 1.6; color: #13213a; margin-bottom: 20px; }

.split-cta {
  align-self: flex-start;
  background: #13213a;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  border: 2px solid #f4c44d;
  transition: all 0.3s ease;
}
.split-cta:hover { background: #0f1b31; transform: translateY(-2px); }
.highlight {
  margin-top: 28px;
  background: #cbc56a;
  color: #ffffff;
  padding: 22px 28px;
  border-radius: 10px;
  font-size: 20px;        /* ⬅️ más grande */
  font-weight: 600;       /* ⬅️ semi-bold */
  line-height: 1.6;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  text-align: center;     /* ⬅️ centrado para más impacto */
}
.highlight strong {
  font-weight: 800;       /* ⬅️ aún más fuerte para destacar */
}

@media (max-width: 900px) {
  .hero-split { grid-template-columns: 1fr; }
  .split-content { padding: 32px 20px; text-align: center; align-items: center; }
  .split-cta { align-self: center; }
}
</style>
